import React, { Component } from 'react';
import ReactImageFallback from "react-image-fallback";
import {IMGIX_PATH} from '../../constants';

import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as galleryActions from "../../actions/gallery";
import AudioItem from "../includes/Slider/AudioItem";
import * as Utils from '../../lib/utils';


class GraphicItem extends Component {

    constructor(props) {
        super(props);
         this.state = {
            visible: false,
            imageId: '',
            showModal : false,
            modalOptions : { showHeader : false, showFooter : false , title : '', id : "galleryModal", content: '' },
             selected_class : ' active',
             downLoad : true,

        };

        this.mToggle = this.mToggle.bind(this);
        this.initiateSlider = this.initiateSlider.bind(this);
        this.playAudio = this.playAudio.bind(this);
        this.closeAudio = this.closeAudio.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
    }

    mToggle() {
        this.setState({ showModal : true, modalOptions:{showModal: this.state.showModal} });
       // this.state.modalOptions.showModal = this.state.showModal;
    }

    initiateSlider(index) {

        var elems = document.querySelectorAll(".carousel-item");
        [].forEach.call(elems, function(el) {
            el.classList.remove("active");
        });
        document.querySelectorAll('.carousel-item')[this.props.galIndex].classList.add('active');

        let data = {"index" :  this.props.galIndex};

        console.log("this.props.galIndex"+this.props.galIndex);
        this.props.setItemId(data);
        if(this.props.galleryInfo.gal_type === 'MY_UPLOADS') {
            let new_class = this.state.wrap_class+ ' '+ this.state.selected_class;
            this.setState({wrap_class : new_class});
        }
        else if(this.props.galleryInfo.gal_type === 'VIDEO') {

            document.querySelectorAll('.video-react-video')[index].play();
        }

    }

    playAudio(index) {

        var element = document.getElementById("audio"+index);

        if( element.parentNode.classList.contains("player-static")) {

            var sounds = document.getElementsByTagName('audio');
            for(var i=0; i<sounds.length; i++){

                sounds[i].pause();

                if(i !== index) {console.log(i+"=============="+index);
                    sounds[i].parentNode.classList.add("player-static");
                }
                else {
                    sounds[i].parentNode.classList.remove("player-static");
                }

            }

            this.setState({wrap_class : 'glery-main sl-item '});

            var audio = document.getElementById("audio"+index);
            audio.play();

        }

    }

    playVideo(index) {

        var element = document.getElementById("audio"+index);

        if( element.parentNode.classList.contains("player-static")) {

            var sounds = document.getElementsByTagName('audio');
            for(var i=0; i<sounds.length; i++){

                sounds[i].pause();

                if(i !== index) {
                    sounds[i].parentNode.classList.add("player-static");
                }
                else {
                    sounds[i].parentNode.classList.remove("player-static");
                }

            }

            this.setState({wrap_class : 'glery-main sl-item '});

            var audio = document.getElementById("audio"+index);
            audio.play();

        }

    }

    closeAudio(e,index) {
        e.preventDefault();
        e.stopPropagation();
        var sound = document.getElementById("audio"+index);
        sound.pause();
        sound.parentNode.classList.add("player-static");
    }

    componentDidMount() {

        let wrap_class = 'glery-main sl-item ';

        if(this.props.galleryInfo.gal_type === 'AUDIO' || this.props.galleryInfo.gal_type === 'VIDEO') {
            wrap_class += ' player-static';
            this.setState({play : false});
        }
        this.setState({wrap_class : wrap_class});

    }
    shouldComponentUpdate(nextProps, nextState){

        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {

    }

    handleDownload(filename,name, fileId){
        Utils.forceDownload(IMGIX_PATH +'assets/slider/'+filename, filename);
        this.props.trackdownload({fileId : fileId});
    }

    render() {
        let item = this.props.detail;
        let itemIndex = this.props.galIndex;
        let imgpath = IMGIX_PATH +'assets/slider/'+ item.img_name+'?fit=crop&h=365&w=400&auto=enhance&dpr=3%203x';
        let defImgSrc ='';

      //  let wrap_class = 'ind-galler-list ';

        if(this.props.galleryInfo.gal_type === 'MY_UPLOADS') {
            defImgSrc = require("../../assets/images/no-gallery.jpg");
        }
        else if(this.props.galleryInfo.gal_type === 'AUDIO') {
            defImgSrc = require("../../assets/images/no-audio.jpg");
        }
        else if(this.props.galleryInfo.gal_type === 'VIDEO') {
            defImgSrc = require("../../assets/images/no-video.jpg");
        }
        else{
            defImgSrc = require("../../assets/images/no-gallery.jpg");
        }

        return (

            <div className={this.state.wrap_class} >
                <div className="gallery-thumb">
                    {this.props.galleryInfo.gal_type === 'AUDIO' &&
                    <button class="file-close" onClick={(e)=>this.closeAudio(e,itemIndex)}></button>
                    }
                    <div className="ind-tb glery-image" data-toggle="modal" data-target="#imagepreview" onClick={() => { this.props.galleryInfo.gal_type === 'AUDIO' ? this.playAudio(itemIndex): this.initiateSlider(itemIndex)  }} >
                    <ReactImageFallback
                        src={imgpath}
                        fallbackImage={defImgSrc}
                        initialImage={defImgSrc}
                        alt="cool image should be here"
                        className="my-image"  />
                    </div>
                    <div className={this.props.galleryInfo.viewMode === "grid"? "ind-tb glery-text audio-white " : "ind-tb glery-text"}>
                        <p>{item.title}</p>
                        {this.state.downLoad && this.props.galleryInfo.gal_type === 'MY_UPLOADS' &&
                        <a onClick={(e) => this.handleDownload(this.props.galleryData.galleryItems[itemIndex].img_name,this.props.galleryData.galleryItems[itemIndex].title, this.props.galleryData.galleryItems[itemIndex].id)} href="javascript:;" >
                            <button className={this.props.galleryInfo.viewMode === "grid" ? "add-image option-down ": "add-image"}></button>
                        </a>
                        }
                        {this.state.downLoad && this.props.galleryInfo.gal_type === 'VIDEO' &&
                        <a onClick={(e) => this.handleDownload(this.props.galleryData.galleryItems[itemIndex].img_name,this.props.galleryData.galleryItems[itemIndex].title, this.props.galleryData.galleryItems[itemIndex].id)} href="javascript:;"
                           download> <button className={this.props.galleryInfo.viewMode === "grid" ? "add-image option-down ": "add-image"}></button></a>
                        }
                    </div>
                    {this.props.galleryInfo.viewMode === "list" &&
                        <div>
                        <div className="ind-tb gal-size">{parseFloat(item.img_size).toFixed(2)}MB</div>
                        <div className="ind-tb gal-user">{item.uploaded_by}</div>
                        <div className="ind-tb gal-date">{item.uploaded_on}</div>


                            {this.state.downLoad && this.props.galleryInfo.gal_type === 'MY_UPLOADS' &&
                            <a onClick={(e) => this.handleDownload(this.props.galleryData.galleryItems[itemIndex].img_name,this.props.galleryData.galleryItems[itemIndex].title, this.props.galleryData.galleryItems[itemIndex].id)} href="javascript:;"
                               download>
                                <button className="add-image option-down" ></button>
                            </a>
                            }
                            {this.state.downLoad && this.props.galleryInfo.gal_type === 'AUDIO' &&
                            <a onClick={(e) => this.handleDownload(this.props.galleryData.galleryItems[itemIndex].img_name,this.props.galleryData.galleryItems[itemIndex].title, this.props.galleryData.galleryItems[itemIndex].id)} href="javascript:;"
                               download> <button className="add-image option-down" ></button></a>
                            }
                            {this.state.downLoad && this.props.galleryInfo.gal_type === 'VIDEO' &&
                            <a onClick={(e) => this.handleDownload(this.props.galleryData.galleryItems[itemIndex].img_name,this.props.galleryData.galleryItems[itemIndex].title, this.props.galleryData.galleryItems[itemIndex].id)} href="javascript:;"
                               download> <button className="add-image option-down" ></button></a>
                            }
                    </div>
                    }
                </div>

                { this.props.galleryInfo.gal_type === 'AUDIO' && <AudioItem item = {item} id={itemIndex}  /> }
            </div>

        );
    }


}

function mapStateToProps(state) {
    return {
        galleryInfo  :state.gallery.galleryUpdate,
        galleryData  :state.gallery.galleryData,
        galleryUpdate  :state.gallery.galleryUpdate
    };

}

export default  withRouter(connect(mapStateToProps, {
    setItemId : galleryActions.setItemId,
    download : galleryActions.downloadFile,
    trackdownload : galleryActions.trackDownload,
})(GraphicItem));




// WEBPACK FOOTER //
// ./src/components/gallery/GraphicItem.js